"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerContactEmail = void 0;
const common_1 = require("../../common");
class PartnerContactEmail extends common_1.MongoSubDocument {
}
exports.PartnerContactEmail = PartnerContactEmail;
//# sourceMappingURL=partner-contact-email.model.js.map